// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","language_switcher_fragment":"fas_language_switcher_fragment","headline":"fas_headline"};